import { z } from "zod";

export const defaultLayout = [
  [
    [
      "summary",
      "socials",
      "experience",
      "hardSkills",
      "education",
      "projects",
      "volunteer",
      "references",
    ],
    ["softSkills", "interests", "certifications", "awards", "publications", "languages"],
  ],
];

// Schema
export const metadataSchema = z.object({
  template: z.string().default("antman"),
  layout: z.array(z.array(z.array(z.string()))).default(defaultLayout), // pages -> columns -> sections
  css: z.object({
    value: z.string().default("* {\n\toutline: 1px solid #000;\n\toutline-offset: 4px;\n}"),
    visible: z.boolean().default(false),
  }),
  page: z.object({
    margin: z.number().default(14),
    format: z.enum(["a4", "letter"]).default("a4"),
    options: z.object({
      breakLine: z.boolean().default(true),
      pageNumbers: z.boolean().default(true),
    }),
  }),
  theme: z.object({
    background: z.string().default("#ffffff"),
    text: z.string().default("#000000"),
    primary: z.string().default("#4cccb8"),
    secondary: z.string().optional(),
  }),
  typography: z.object({
    font: z.object({
      family: z.string().default("Josefin Sans"),
      subset: z.string().default("latin"),
      variants: z.array(z.string()).default(["regular"]),
      defaultVariant: z.string().default("regular"),
      size: z.number().default(14),
    }),
    nameSize: z.number().default(24),
    headlineSize: z.number().default(16),
    nameLineHeight: z.number().default(1.2),
    headlineLineHeight: z.number().default(1.25),
    lineHeight: z.number().default(1.5),
    hideIcons: z.boolean().default(false),
    underlineLinks: z.boolean().default(true),
  }),
  notes: z.string().default(""),
});

// Type
export type Metadata = z.infer<typeof metadataSchema>;

// Defaults
export const defaultMetadata: Metadata = {
  template: "antman",
  layout: defaultLayout,
  css: {
    value: "* {\n\toutline: 1px solid #000;\n\toutline-offset: 4px;\n}",
    visible: false,
  },
  page: {
    margin: 18,
    format: "a4",
    options: {
      breakLine: true,
      pageNumbers: true,
    },
  },
  theme: {
    background: "#ffffff",
    text: "#000000",
    primary: "#4cccb8",
    secondary: "#fda100",
  },
  typography: {
    font: {
      family: "Josefin Sans",
      subset: "latin",
      variants: ["regular"],
      defaultVariant: "regular",
      size: 13,
    },
    nameSize: 24,
    headlineSize: 16,
    nameLineHeight: 1.2,
    headlineLineHeight: 1.25,
    lineHeight: 1.75,
    hideIcons: false,
    underlineLinks: true,
  },
  notes: "",
};
